<template>
  <div class="page-content">
    <Steps :active="2"></Steps>
    <PageTitle text="订单信息"></PageTitle>
    <div class="section">
      <div class="line">
        <p class="label">订单号</p>
        <p>
          {{ orderInfo.wx_order_no }}
        </p>
      </div>
      <div class="line">
        <p class="label">下单时间</p> <p>{{ orderInfo.create_time }}</p>
      </div>

      <div class="line" v-if="orderInfo.buyer_name">
        <p class="label">购买人姓名</p>
        <p>{{ orderInfo.buyer_name }}</p>
      </div>

      <div class="line" v-if="orderInfo.buyer_phone">
        <p class="label">购买人手机</p>
        <p>{{ orderInfo.buyer_phone }}</p>
      </div>

      <div class="line" v-if="orderInfo.buyer_identify">
        <p class="label">购买人证件号</p>
        <p>{{ orderInfo.buyer_identify }}</p>
      </div>

      <div class="line">
        <p class="label">订单内容</p>
        <p class="ticket-info-content">

        </p>
      </div>

      <TicketItems :tickets="orderInfo.tickets" style="margin-bottom:10px"></TicketItems>

      <div class="line">
        <p class="label">总价格</p>
        <p class="ticket-info-content price">
          ￥{{ orderInfo.price }}
        </p>
      </div>
    </div>
    <PageTitle text="支付方式"></PageTitle>
    <div class="section">
      <el-radio-group class="check-group" v-model="payWay">
        <el-radio :label="item.value" v-for="(item,index) in pay_way" :key="index">
          <img class="pay-icon" :src="item.icon" alt=""> {{ item.name }}
          <span class="pay-tip" v-if="item.name ==='扫码支付'">（支持微信、支付宝、建行App。）</span>
        </el-radio>
      </el-radio-group>
      <p class="pay-notice">请于下单后10分钟内完成支付，超时订单将被取消</p>
    </div>
    <div class="order-submit">
      <div class="back-btn" @click="$router.go(-1)">返回</div>
      <div class="order-btn" @click="getQrcode">下一步</div>
    </div>
    <PayDialog
      ref="payDialog"
      :title="payMap[payWay]+'扫码支付'"
      :payWay="payWay"
      :qrcode="qrcode"
      :orderId="orderInfo.id"
      :orderNo="orderInfo.wx_order_no"
    >
    </PayDialog>
  </div>
</template>
<script>
import '@/style/page.less'
import { getOrderDetail, getWxQrcode, getAliQrcode, getJianHangQrcode } from '@/api'
import Steps from '@/components/Steps'
import PayDialog from '@/components/PayDialog'
import PageTitle from '@/components/PageTitle'
import TicketItems from '@/components/TicketItems'

const payMap = {
  WEIXIN: '微信',
  ALI: '支付宝',
  JIANHANG: '扫码支付'
}

export default {
  components: {
    PayDialog, Steps, PageTitle, TicketItems
  },
  computed: {
    pay_way () {
      return this.$store.state.projectConfig.app_pc_pay_way.map(i => {
        return {
          value: i,
          name: payMap[i],
          icon: require(`../assets/icon/${i}.png`)
        }
      })
    }
  },
  data () {
    return {
      payMap,
      payWay: 'WEIXIN',
      orderInfo: {},
      ticketInfo: {},
      qrcode: '',
      dialogVisible: false
    }
  },
  created () {
    this.getOrderDetail()
  },
  methods: {
    getOrderDetail () {
      return getOrderDetail(this.$route.params.id).then(res => {
        this.orderInfo = res.data.extraInfo
        this.ticketInfo = this.orderInfo.tickets[0]
        if (res.data.extraInfo.pay_status === 'PAYED') {
          clearTimeout(this.timeout)

          this.$message.success('支付成功')
          this.$router.push('/myOrder')
        } else {
          this.timeout && clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            this.getOrderDetail()
          }, 2000)
        }
      })
    },
    getQrcode () {
      const params = {
        order_no: this.orderInfo.wx_order_no,
        fee: this.orderInfo.price
      }

      const actions = {
        WEIXIN: {
          method: getWxQrcode,
          property: 'code_url'
        },
        ALI: {
          method: getAliQrcode,
          property: 'qr_code'
        },
        JIANHANG: {
          method: getJianHangQrcode,
          property: 'qr_code'
        }
      }

      if (actions[this.payWay]) {
        actions[this.payWay].method(params).then(res => {
          this.qrcode = res.data.extraInfo[actions[this.payWay].property]
          this.$refs.payDialog.open()
        })
      } else {
        alert('未注册的支付方式' + this.payWay)
      }
    }
  },
  beforeDestroy () {
    this.timeout && window.clearTimeout(this.timeout)
  }
}
</script>
<style lang="less">
.check-group {
  display: flex;
  .el-radio {
    display: flex; align-items: center;
    .el-radio__label {
      display: flex; align-items: center;
      .pay-icon {
        margin-right: 10px;
        width: 30px; height:30px;
      }
      .pay-tip{
        font-size: 12px;
        color: grey;
      }
    }
  }
}
.pay-notice {
  margin-top: 10px;
  font-size: 14px;
}
</style>
